import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { LocationService } from '../../../services/location.service';
import { TranslateService } from '@ngx-translate/core';



@Component({
    selector: 'app-user-management',
    templateUrl: './user-management.component.html',
    styleUrls: ['./user-management.component.scss']
})
export class UserManagementComponent implements OnInit {

    reloadTable = false;
    _tableSettings: ITabelSetttings;
    _tableData: ITableData;
    _modalSettings: IModalSettings;
    user = {} as ILocationUser;
  validSettings: boolean = true;
  constructor(private locationService: LocationService, private translateService: TranslateService) {
    }

    onUpdateUser(event) {
        this.user = event;
    }
    private reloadSource = new Subject();
    reloadStatus = this.reloadSource.asObservable();
    refresh(type) {
        this.reloadSource.next(type)
        this.reloadTable = type;
    }
  ngOnInit() {
    this._modalSettings = {
        content: this.translateService.instant("pages.userManagement.userPopup.content"),
        name: this.translateService.instant("pages.userManagement.userPopup.name"),
        size: 2,
        type: 5,
        to: 1
    }
    this._tableSettings = {
        header: this.translateService.instant("pages.userManagement.manageTable.header"),
        searchable: true,
        classes: ["all"],
        API: {
            fetch: "USERS_IN_LOCATION",
            getByRow: "GET_USER"
        }
    }

    this._tableData = {
        pageCount: 10,
        tr: [],
        th: [
            '',
            this.translateService.instant("common.fullName"),
            this.translateService.instant("common.email"),
            this.translateService.instant("common.roles"),
            this.translateService.instant("common.status"),
            this.translateService.instant("common.actions")
        ]
    }

    this.locationService.getLocationRoles((res) => {
      this.locationService = res;
      //console.log(res)
    }, (err) => { })
  }
  

}
